
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const invitaionApi = {
	
	//查詢邀请记录和相应的用户
	"queryAdditionalrecord10InfoList": {
	    send: (data, callback, failCallback, errorCallback) => {
	        postRequest(`${baseUrl.shopopeeHttp}record10/queryAdditionalrecord10InfoList`, data, callback, failCallback, errorCallback)
	    },
	    getParams: () => {
	        return {
	            addinfo1: null,//companyCode
	        }
	    }
	},
}

export default invitaionApi